import React from 'react'

import { DialogActions as MuiDialogActions, DialogActionsProps } from '@material-ui/core'

const DialogActions: React.FC<DialogActionsProps> = ({ children, ...rest }) => (
  <MuiDialogActions {...rest}>{children}</MuiDialogActions>
)

export default DialogActions
